import { Link } from 'react-router-dom';

/**
 * Control Hero Variant - "Are you green?"
 * WP-LANDING-6: Gamified hero with heatmap color metaphor
 */
export function HeroControl() {
  return (
    <section className="bg-white">
      <div className="max-w-4xl mx-auto px-4 pt-16 pb-8 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl mb-6">
          Are you green for retirement?
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
          Check below to see.
        </p>
        <Link
          to="/register"
          className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg shadow-sm transition-colors"
        >
          Get Started
        </Link>
      </div>
    </section>
  );
}

/**
 * Variant A: "Get green" - imperative, action-oriented
 * WP-LANDING-6
 */
export function HeroVariantA() {
  return (
    <section className="bg-white">
      <div className="max-w-4xl mx-auto px-4 pt-16 pb-8 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl mb-6">
          Get green for retirement.
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
          Check below to see where you stand.
        </p>
        <Link
          to="/register"
          className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg shadow-sm transition-colors"
        >
          Get Started Free
        </Link>
      </div>
    </section>
  );
}

/**
 * Variant B: "How green" - curiosity-driven
 * WP-LANDING-6
 */
export function HeroVariantB() {
  return (
    <section className="bg-white">
      <div className="max-w-4xl mx-auto px-4 pt-16 pb-8 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl mb-6">
          How green is your retirement?
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
          Check below to find out.
        </p>
        <Link
          to="/register"
          className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg shadow-sm transition-colors"
        >
          Start Planning Now
        </Link>
      </div>
    </section>
  );
}
